module.exports = __webpack_public_path__ + "img/filigrana-incantalia-right.2577815a.png";